namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class CustomersWhatsAppDialog extends Serenity.EntityDialog<CustomersRow, any> {
        protected getFormKey() { return CustomersWhatsAppForm.formKey; }
        protected getIdProperty() { return CustomersRow.idProperty; }
        protected getLocalTextPrefix() { return CustomersRow.localTextPrefix; }
        protected getService() { return CustomersService.baseUrl; }

        protected form = new CustomersWhatsAppForm(this.idPrefix);
        public rowids: string;

        constructor(gridToRefresh, FormMode, rowKeys) {
            super();

            this.form = new CustomersWhatsAppForm(this.idPrefix);
            this.rowids = rowKeys;
            this.form.RowIds.value = rowKeys;
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                {
                    text: 'Send WhatsApp Message',
                    click: () => {
                        const status = this.form.Status.value;
                        const selectedIds = this.form.RowIds.value;

                        if (!status || !selectedIds) {
                            Q.alert('Please enter a message and select at least one recipient.');
                            return;
                        }

                        // Call the backend service to send WhatsApp messages
                        CustomersService.SendWhatsAppMessage({
                            ids: selectedIds,
                            Status: status
                        }, response => {
                            Q.notifySuccess('WhatsApp messages sent successfully!');
                            this.dialogClose();
                        }, {
                            blockUI: true,
                            onError: (error) => {
                                Q.notifyError('Failed to send WhatsApp messages.');
                            }
                        });
                    }
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

        protected getDialogTitle(): string {
            return "Send WhatsApp Message";
        }
    }
}
